var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('site-menu'), _c('div', {
    staticClass: "s-pageheader",
    attrs: {
      "id": "top"
    }
  }, [_c('page-header')], 1), _c('section', {
    staticClass: "s-content s-content--narrow"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form"
  }, [_c('div', {
    staticClass: "profile-container"
  }, [_vm._t("default")], 2)])])]), _c('page-footer')], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }